// The visitor's choices stay in this browser: localStorage under a prefix ("companions." by
// default), and the Pause choice in sessionStorage, for this visit only. Blocked storage (private
// windows, blocked site data) and a full quota fall back to memory (runtime/storage.js).
import { createStorage } from '../runtime/storage.js';

// Reading window.localStorage itself throws where site data is blocked.
function area(name) {
  try { return globalThis[name] || null; } catch { return null; }
}

export const prefixOf = name => String(name ?? 'companions').replace(/\.?$/, '.');

export function namespaced(name, prefix) {
  const s = area(name);
  return createStorage(s && { get: key => s.getItem(prefix + key), set: (key, value) => s.setItem(prefix + key, value) });
}

// Forgets everything kept under the prefix, in both places.
export function forget(prefix) {
  for (const name of ['localStorage', 'sessionStorage']) {
    try {
      const s = area(name);
      if (!s) continue;
      const keys = [];
      for (let i = 0; i < s.length; i++) if (s.key(i)?.startsWith(prefix)) keys.push(s.key(i));
      for (const key of keys) s.removeItem(key);
    } catch { /* nothing kept there */ }
  }
}
